<script setup>
import { mapErrors } from '@/utilities';
import { useForm } from '@inertiajs/vue3';
import { inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';

// Components
import Button from '@/Components/Button/Button.vue';

const submittedForm = ref(false);
const { t } = useI18n();

const form = useForm({
    name: '',
    email: '',
});
const route = inject('route');
const sendForm = () => {
    form.post(route('api.newsletter-form'), {
        preserveState: true,
        preserveScroll: true,
        wantsJson: true,
        onSuccess: () => {
            submittedForm.value = true;
        },
        onError: (errors) => (form.errors = mapErrors(errors)),
    });
};
</script>

<template>
    <div class="w-8/12 mt-10">
        <div v-if="submittedForm">
            <p class="text-center">
                {{ t('Thank you for your sign up!') }}
            </p>
        </div>
        <FormKit type="form" id="contact-form" @submit="sendForm" :actions="false" v-else>
            <div class="flex flex-col gap-3 lg:flex-row">
                <FormKit
                    type="text"
                    name="name"
                    :placeholder="t('Name *')"
                    v-model="form.name"
                    :errors="form.errors.name"
                    validation="required|name"
                    :value="form.name"
                    :classes="{
                        input: 'min-h-[51px]',
                    }"
                />

                <FormKit
                    type="email"
                    name="email"
                    :placeholder="t('E-mail *')"
                    validation="required|email"
                    :errors="form.errors.email"
                    v-model="form.email"
                    :classes="{
                        input: 'min-h-[51px]',
                    }"
                />

                <Button is="button" @click="sendForm" :label="t('Submit')" :form="form" class="w-auto" />
            </div>
        </FormKit>
    </div>
</template>
